import { type SVGProps } from "react";

export const IdCardSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <circle cx={41.757} cy={42.758} r={32} fill="#F1F5F9" transform="rotate(5.116 41.757 42.758)" />
    <rect
      width={34.57}
      height={65.436}
      x={18.566}
      y={13.525}
      fill="#fff"
      rx={4}
      transform="rotate(-11.496 18.566 13.525)"
    />
    <path fill="#94A3B8" d="M22.197 25.285 53.69 18.88l5.168 25.407-31.494 6.405z" opacity={0.7} />
    <rect
      width={29.741}
      height={21.099}
      x={40.821}
      y={23.263}
      fill="#fff"
      stroke="#0F172A"
      strokeWidth={1.125}
      rx={1.613}
      transform="rotate(-1.248 40.82 23.263)"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M51.991 37.363a3.743 3.743 0 0 0-2.99-1.488 3.745 3.745 0 0 0-2.992 1.488m5.982 0A4.499 4.499 0 0 0 49 29.5a4.5 4.5 0 0 0-2.99 7.863m5.981 0a4.484 4.484 0 0 1-2.99 1.137 4.483 4.483 0 0 1-2.992-1.137m4.491-4.488a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    />
    <path stroke="#000" d="M56 32h11.5M56 34h8.5M56 36h9.5" />
    <path
      fill="#B0BCCC"
      d="m41.688 40.257 28.778-.513.045 2.5a1 1 0 0 1-.982 1.017l-26.78.477a1 1 0 0 1-1.017-.982l-.044-2.5ZM70.082 26.502l-28.604.75-.054-2.396a1.03 1.03 0 0 1 1.002-1.053l26.45-.693a1.125 1.125 0 0 1 1.154 1.099l.052 2.293Z"
    />
    <circle
      cx={46.824}
      cy={65.735}
      r={2.469}
      fill="#0F172A"
      transform="rotate(-11.496 46.824 65.735)"
    />
    <rect
      width={33.07}
      height={63.936}
      x={19.451}
      y={14.111}
      stroke="#000"
      strokeWidth={1.5}
      rx={3.25}
      transform="rotate(-11.496 19.45 14.11)"
    />
  </svg>
);
